import {ReactComponent as HighBeam} from "./1.svg";
import {ReactComponent as LowBeam} from "./6.svg";
import {ReactComponent as DangerAlert} from "./17.svg";
import {ReactComponent as FrontFogLamp} from "./3.svg";
import {ReactComponent as BackFogLamp} from "./2.svg";
import {ReactComponent as TurnSignals} from "./19.svg";
import {ReactComponent as BrakeLights} from "./9.svg";
import {ReactComponent as PositionSideLambs} from "./7.svg";
import {ReactComponent as AirCondition} from "./65.svg";
import {ReactComponent as ParkingHeating} from "./79.svg";
import {ReactComponent as TrailerTied} from "./47.svg";
import {ReactComponent as DisabledPeople} from "./93.svg";
import {ReactComponent as FuelLevel} from "./55.svg";
import {ReactComponent as EngineOil} from "./53.svg";
import {ReactComponent as HandBrake} from "./18.svg";
import {ReactComponent as CeilingCover} from "./82.svg";
import {ReactComponent as SafetyBelt} from "./88.svg";
import {ReactComponent as StopRequest} from "./91.svg";
import {ReactComponent as EngineShaftIndicator} from "./89.svg";
import {ReactComponent as Airbag} from "./87.svg";
import {ReactComponent as ArticulatedVehicle} from "./97.svg";
import {ReactComponent as CleverCharge} from "./41.svg";
import {ReactComponent as BabyCar} from "./94.svg";
import {ReactComponent as HeightControl} from "./95.svg";
import {ReactComponent as AirPressureLev} from "./90.svg";
import {ReactComponent as AbsTrailer12} from "./31.svg";
import {ReactComponent as EscClosed} from "./57.svg";
import {ReactComponent as Ebs} from "./ebs.svg";
import {ReactComponent as LaneDeparture} from "./50.svg";
import {ReactComponent as BusStopBrake} from "./49.svg";
import {ReactComponent as EmergencyBrakingSystem} from "./37.svg";
import {ReactComponent as AirFilter} from "./96.svg";
import {ReactComponent as AdBlue} from "./adblue.svg";
import {ReactComponent as Retarder} from "./83.svg";
import {ReactComponent as Acc} from "./acc.svg";
import {ReactComponent as TireFailure} from "./77.svg";
import {ReactComponent as ServiceRepair} from "./48.svg";
import {ReactComponent as TransmissionFluidTemperature} from "./54.svg";
import {ReactComponent as GearboxFailure} from "./45.svg";
import {ReactComponent as EngineOilTemprature} from "./35.svg";
import {ReactComponent as EngineCoolantLevel} from "./52.svg";
import {ReactComponent as SteeringFluidLevel} from "./39.svg";
import {ReactComponent as FuelFilterDifferentialPressure} from "./92.svg";
import {ReactComponent as EngineEmissionSystemMalfunction} from "./51.svg";
import {ReactComponent as BrakeFailure} from "./BrakeFailure.svg";
import {ReactComponent as BusDoor} from "./door.svg";
import {ReactComponent as BusFuel} from "./bus-fuel.svg";
import {ReactComponent as BusSpeed} from "./bus-speed.svg";
import {ReactComponent as TurnLights} from "./turn-lights.svg";
import {ReactComponent as WindshieldWiperFluid} from "./WindshieldWiperFluid.svg";
import {ReactComponent as WornBrakeFailure} from "./WornBrakeFailure.svg";
import {ReactComponent as ABSFailure} from "./ABSFailure.svg";
import {ReactComponent as CallService} from "./CallService.svg";
import {ReactComponent as StreeringFluildLevel} from "./StreeringFluildLevel.svg";
import {ReactComponent as EnginecoolantLevel} from "./EnginecoolantLevel.svg";
import {ReactComponent as ESCClosed} from "./ESCClosed.svg";
import {ReactComponent as ParkBurning} from "./ParkBurning.svg";
import {ReactComponent as EngineComptemp} from "./enginecomparentmenttemp.svg";
import {ReactComponent as Lowering} from "./lowering.svg";
import {ReactComponent as ACC} from "./klima.svg";
import {ReactComponent as Raising} from "./raising.svg";
import {ReactComponent as Kneeling} from "./kneeling.svg";
import {ReactComponent as TacoGraphy} from "./takograf.svg";
import {ReactComponent as LaneOff} from "./laneoff.svg";
import {ReactComponent as CloseCircle} from "./close-circle.svg";

const Icons = {
    HighBeam,
    LowBeam,
    DangerAlert,
    FrontFogLamp,
    BackFogLamp,
    TurnSignals,
    BrakeLights,
    PositionSideLambs,
    AirCondition,
    ParkingHeating,
    TrailerTied,
    DisabledPeople,
    FuelLevel,
    EngineOil,
    HandBrake,
    CeilingCover,
    SafetyBelt,
    StopRequest,
    EngineShaftIndicator,
    Airbag,
    ArticulatedVehicle,
    CleverCharge,
    BabyCar,
    HeightControl,
    AirPressureLev,
    AbsTrailer12,
    EscClosed,
    Ebs,
    LaneDeparture,
    BusStopBrake,
    EmergencyBrakingSystem,
    AirFilter,
    AdBlue,
    Retarder,
    Acc,
    TireFailure,
    ServiceRepair,
    TransmissionFluidTemperature,
    GearboxFailure,
    EngineOilTemprature,
    EngineCoolantLevel,
    SteeringFluidLevel,
    FuelFilterDifferentialPressure,
    EngineEmissionSystemMalfunction,
    BrakeFailure,
    BusDoor,
    BusSpeed,
    BusFuel,
    TurnLights,
    WindshieldWiperFluid,
    WornBrakeFailure,
    ABSFailure,
    CallService,
    StreeringFluildLevel,
    EnginecoolantLevel,
    ESCClosed,
    ParkBurning,
    EngineComptemp,
    Lowering,
    ACC,
    Raising,
    TacoGraphy,
    Kneeling,
    LaneOff,
    CloseCircle
}

export default Icons;

